/**
 * Used internally to parse fields returned by the ArcGIS component to a more readable format
 * */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function getAddressFieldsInternal(address, location) {
    const newAddress = {};
    // Reverse geocoding doesn't return a place name. Instead it returns either a Address or ShortLabel field
    if (address === null || address === void 0 ? void 0 : address.Address) {
        newAddress.placeName = address.Address;
    }
    if (address === null || address === void 0 ? void 0 : address.PlaceName) {
        newAddress.placeName = address.PlaceName;
    }
    if (address === null || address === void 0 ? void 0 : address.StAddr) {
        newAddress.streetName = address.StAddr;
    }
    if (address === null || address === void 0 ? void 0 : address.City) {
        newAddress.city = address.City;
    }
    if (address === null || address === void 0 ? void 0 : address.RegionAbbr) {
        newAddress.state = address.RegionAbbr;
    }
    if (address === null || address === void 0 ? void 0 : address.Subregion) {
        newAddress.county = address.Subregion;
    }
    if (address === null || address === void 0 ? void 0 : address.Postal) {
        newAddress.postalCode = address.Postal;
    }
    if (location) {
        newAddress.location = {
            latitude: location.y,
            longitude: location.x,
        };
    }
    return newAddress;
}
